import api from './api';

export const trialDataEntryService = {
  // Get all trials for data entry view
  async getAllTrials() {
    try {
      const response = await api.get('/trials');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trials');
    }
  },

  // Get trial assignments for data entry
  async getTrialAssignments() {
    try {
      const response = await api.get('/trials/trial/assignments/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial assignments');
    }
  },

  // Get data entries for a specific trial location
  async getDataEntries(trialId, locationId) {
    try {
      const response = await api.get(`/trials/${trialId}/locations/${locationId}/data-entries`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data entries');
    }
  },

  // Submit data entry
  async submitDataEntry(trialId, locationId, entryData) {
    try {
      const response = await api.post(`/trials/${trialId}/locations/${locationId}/data-entries`, entryData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to submit data entry');
    }
  },

  // Update data entry
  async updateDataEntry(entryId, entryData) {
    try {
      const response = await api.put(`/data-entries/${entryId}`, entryData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update data entry');
    }
  },

  // Delete data entry
  async deleteDataEntry(entryId) {
    try {
      const response = await api.delete(`/data-entries/${entryId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete data entry');
    }
  },

  // Bulk create data entries
  async bulkCreateDataEntries(trialId, locationId, entriesData) {
    try {
      const response = await api.post(`/trials/${trialId}/locations/${locationId}/data-entries/bulk`, entriesData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create bulk data entries');
    }
  },

  // Get observations for a trial
  async getTrialObservations(trialId) {
    try {
      const response = await api.get(`/trials/${trialId}/observations`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial observations');
    }
  },

  // Get cultures for a trial
  async getTrialCultures(trialId) {
    try {
      const response = await api.get(`/trials/${trialId}/cultures`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch trial cultures');
    }
  },

  // Upload photo for data entry
  async uploadPhoto(trialId, locationId, photoData) {
    try {
      const formData = new FormData();
      formData.append('photo', photoData.file);
      formData.append('description', photoData.description || '');
      formData.append('entryDate', photoData.entryDate);
      
      const response = await api.post(`/trials/${trialId}/locations/${locationId}/photos`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to upload photo');
    }
  },

  // Get photos for a trial location
  async getPhotos(trialId, locationId) {
    try {
      const response = await api.get(`/trials/${trialId}/locations/${locationId}/photos`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch photos');
    }
  },

  // Get data entry history
  async getDataEntryHistory(trialId, locationId, filters = {}) {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const response = await api.get(`/trials/${trialId}/locations/${locationId}/data-entries/history?${queryParams}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data entry history');
    }
  },

  // Export data entries
  async exportDataEntries(trialId, locationId, format = 'excel', filters = {}) {
    try {
      const queryParams = new URLSearchParams({ ...filters, format }).toString();
      const response = await api.get(`/trials/${trialId}/locations/${locationId}/data-entries/export?${queryParams}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to export data entries');
    }
  },

  // Get data entry statistics
  async getDataEntryStats(trialId, locationId) {
    try {
      const response = await api.get(`/trials/${trialId}/locations/${locationId}/data-entries/stats`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch data entry statistics');
    }
  }
};
